import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthService } from '../auth/auth.service';
import { EnvironmentConfigService } from './../environment/environment-config.service';

@Injectable()
export class HttpAuthInterceptorService implements HttpInterceptor {
  // keep the lock to the refresh token so we only send the request to oauth issue once
  _refreshTokenInProgress = false;
  _oAuthIssuerEndpoint: string;
  constructor(
    private authService: AuthService,
    private environmentConfigService: EnvironmentConfigService
  ) {
    this._oAuthIssuerEndpoint =
      this.environmentConfigService.getEnvironmentConfigs() &&
      this.environmentConfigService.getEnvironmentConfigs().sso.issuer;
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // not to include token for call to issuer
    // do not refresh token if the previous call already made it
    if (
      (request.url && request.url.startsWith(this._oAuthIssuerEndpoint)) ||
      this._refreshTokenInProgress
    ) {
      return next.handle(request);
    }
    //add token to the requests
    return next.handle(this.updateHeader(request)).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      })
    );
  }
  updateHeader(req: HttpRequest<any>) {
    if (req.url && req.url.startsWith(this._oAuthIssuerEndpoint)) {
      return req;
    }
    
    return req.clone({
      withCredentials: true,
    });
  }
}
